import {DimensionValue, StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  containerMenuItemIsHome: {
    flex: 1,
    marginHorizontal: 0,
  },
  containerMenuItemProfil: {
    flex: 1,
    marginHorizontal: 10,
  },
  bkgAirtel: {
    backgroundColor: '#e80115',
  },
  containerPaimentItem: {
    overflow: 'hidden',
    height: 134,
    width: 110,
    marginTop: 8,
    marginRight: 8,
    marginLeft: 8,
    marginBottom: 8,
    paddingHorizontal: 10,
    paddingVertical: 8,
    backgroundColor: '#ffde00',
    borderRadius: 16,
    alignItems: 'center',
    justifyContent: 'flex-start',
    flex: 1,
    shadowColor: '#000000',
    shadowOffset: {
      width: 1,
      height: 0,
    },
    shadowOpacity: 0.1,
    shadowRadius: 50,
    elevation: 4,
  },
  containerPaimentItemOrange: {
    overflow: 'hidden',
    height: 134,
    width: 110,
    marginTop: 8,
    marginRight: 8,
    marginLeft: 8,
    marginBottom: 8,
    paddingHorizontal: 10,
    // paddingVertical: 8,
    backgroundColor: '#000000',
    borderRadius: 16,
    alignItems: 'center',
    justifyContent: 'flex-start',
    flex: 1,
    shadowColor: '#000000',
    shadowOffset: {
      width: 1,
      height: 0,
    },
    shadowOpacity: 0.1,
    shadowRadius: 50,
    elevation: 4,
  },
  containerPaimentItemAirtel: {
    overflow: 'hidden',
    height: 134,
    width: 110,
    marginTop: 8,
    marginRight: 8,
    marginLeft: 8,
    marginBottom: 8,
    paddingHorizontal: 10,
    backgroundColor: '#e80115',
    borderRadius: 16,
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexBasis: 'calc(50% - 16px)' as DimensionValue,
    shadowColor: '#000000',
    shadowOffset: {
      width: 1,
      height: 0,
    },
    shadowOpacity: 0.1,
    shadowRadius: 50,
    elevation: 4,
  },
  containerPaimentItemAirtelMobile: {
    overflow: 'hidden',
    height: 134,
    width: 110,
    marginTop: 8,
    marginRight: 8,
    marginLeft: 8,
    marginBottom: 8,
    paddingHorizontal: 10,
    backgroundColor: '#e80115',
    borderRadius: 16,
    alignItems: 'center',
    justifyContent: 'flex-start',
    flex: 0.5,
    shadowColor: '#000000',
    shadowOffset: {
      width: 1,
      height: 0,
    },
    shadowOpacity: 0.1,
    shadowRadius: 50,
    elevation: 4,
  },
  containerPaimentItemVisa: {
    overflow: 'hidden',
    height: 134,
    width: 110,
    marginTop: 8,
    marginRight: 8,
    marginLeft: 8,
    marginBottom: 8,
    paddingHorizontal: 10,
    // paddingVertical: 8,
    backgroundColor: '#ffffff',
    borderRadius: 16,
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexBasis: 'calc(50% - 16px)' as DimensionValue,
    shadowColor: '#000000',
    shadowOffset: {
      width: 1,
      height: 0,
    },
    shadowOpacity: 0.1,
    shadowRadius: 50,
    elevation: 4,
  },
  containerPaimentItemVisaMobile: {
    overflow: 'hidden',
    height: 134,
    width: 110,
    marginTop: 8,
    marginRight: 8,
    marginLeft: 8,
    marginBottom: 8,
    paddingHorizontal: 10,
    backgroundColor: '#ffffff',
    borderRadius: 16,
    alignItems: 'center',
    justifyContent: 'flex-start',
    flex: 0.5,
    shadowColor: '#000000',
    shadowOffset: {
      width: 1,
      height: 0,
    },
    shadowOpacity: 0.1,
    shadowRadius: 50,
    elevation: 4,
  },
  containerPaimentItemComptant: {
    overflow: 'hidden',
    height: 134,
    width: 110,
    marginTop: 8,
    marginRight: 8,
    marginLeft: 8,
    marginBottom: 8,
    paddingHorizontal: 10,
    backgroundColor: '#ffffff',
    borderRadius: 16,
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexBasis: 'calc(50% - 16px)' as DimensionValue,
    shadowColor: '#000000',
    shadowOffset: {
      width: 1,
      height: 0,
    },
    shadowOpacity: 0.1,
    shadowRadius: 50,
    elevation: 4,
  },
  containerPaimentItemComptantMobile: {
    overflow: 'hidden',
    height: 134,
    width: 110,
    marginTop: 8,
    marginRight: 8,
    marginLeft: 8,
    marginBottom: 8,
    paddingHorizontal: 10,
    backgroundColor: '#ffffff',
    borderRadius: 16,
    alignItems: 'center',
    justifyContent: 'flex-start',
    flex: 0.45,
    shadowColor: '#000000',
    shadowOffset: {
      width: 1,
      height: 0,
    },
    shadowOpacity: 0.1,
    shadowRadius: 50,
    elevation: 4,
  },
  containerMenuItem: {
    height: 134,
    marginTop: 8,
    marginRight: 8,
    marginLeft: 8,
    marginBottom: 8,
    paddingHorizontal: 10,
    backgroundColor: 'white',
    borderRadius: 16,
    alignItems: 'center',
    justifyContent: 'flex-start',
    flex: 1,
    shadowColor: '#000000',
    shadowOffset: {
      width: 3,
      height: 0,
    },
    shadowOpacity: 0.1,
    shadowRadius: 16,
    elevation: 2,
  },
  itemMyPayment: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  MenuItemFont: {
    fontSize: 14,
    textAlign: 'center',
    marginBottom: 8,
  },
  MenuItemLogo: {
    marginTop: 0,
    marginBottom: 0,
  },
  spaceItemLogo: {
    width: 134,
    height: 134,
  },
  spaceItemLogoPayment: {
    width: 134,
    height: 134,
    paddingTop: 10,
    marginRight: 0,
    marginTop: 0,
  },
  linearGradient: {
    flex: 1,
    paddingLeft: 15,
    paddingRight: 15,
    borderRadius: 5,
  },
});
